
export default function SmallInfo (props){
    return(
        <div style={{backgroundColor:"#1D1D1D", width: "fit-content", margin:props.margin}}>
            <p style={{margin: "10px",  whiteSpace: "nowrap", padding:"13px",paddingLeft: props.paddingLeft, paddingRight:props.paddingRight, color:"white", fontSize:props.fontSize}}>{props.text}</p>
        </div>
    );
}